import React, { useState, useEffect } from "react";
import "../Styles/ScrollFlightProgress.css";

export default function ScrollFlightProgress() {
  const [scrollPercentage, setScrollPercentage] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (documentHeight - windowHeight <= 0) {
        setScrollPercentage(0);
        return;
      }

      const totalScroll = (scrollTop / (documentHeight - windowHeight)) * 100;
      setScrollPercentage(Math.min(Math.max(totalScroll, 0), 100));
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // initial sync

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="scroll-flight-bar-wrapper" aria-hidden="true">
      <div
        className="scroll-flight-line"
        style={{ width: `${scrollPercentage}%` }}
      >
        <div className="scroll-flight-glow" />
        <div className="scroll-mini-jet">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2 14V16L10 13.5V19L8 20.5V22L11.5 21L15 22V20.5L13 19V13.5L21 16Z" />
          </svg>
        </div>
      </div>
    </div>
  );
}
